import React, { useState } from "react";
import { AiFillWallet } from "react-icons/ai";
import { FaWallet } from "react-icons/fa";
// Material UI components
import ConnectWalletPopUp from "../ConnectWalletPopUp/ConnectWalletPopUp";
import { TiCancel } from "react-icons/ti";
import {
  Avatar,
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";

// Icons

import MetaMaskIcon from "../../assets/Icons/darkUIIcons/metaMaskIcon.svg";
import MetaMaskIconLight from "../../assets/Icons/lightUIIcons/metaMaskIcon.svg";
import { GiBugleCall } from "react-icons/gi";
import {
  BsChevronDown,
  BsChevronUp,
  BsQuestionOctagonFill,
  BsFillStarFill,
  BsLightbulbFill,
  BsFillBookmarkFill,
  BsGearFill,
} from "react-icons/bs";
import NavUserAvatar from "../../assets/navUserAvatar.png";
import { RiInstagramLine, RiTwitterFill } from "react-icons/ri";
import { MdLock } from "react-icons/md";
import { IoPersonSharp, IoLanguage } from "react-icons/io5";
import { IoIosSwitch } from "react-icons/io";
import { AiFillIdcard } from "react-icons/ai";
import { CgLoadbarDoc } from "react-icons/cg";

import LoginIcon from "@mui/icons-material/Login";

import GavelIcon from "@mui/icons-material/Gavel";
import LogoutIcon from "@mui/icons-material/Logout";

// Modules
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import KeyIconDark from "../../assets/Icons/darkUIIcons/keyIconDark.svg";
import KeyIconLight from "../../assets/Icons/lightUIIcons/change-pass-icon.svg";
import DocumentEditIcon from "../../assets/Icons/darkUIIcons/documentEditIconDark.svg";
import DocumentEditIconLight from "../../assets/Icons/lightUIIcons/change-email-icon.svg";

// Logos
import SideFooterLogoLight from "../../assets/sideFooterLogoLight.svg";
import SideFooterLogoDark from "../../assets/sideFooterLogoDark.svg";
import useAuth from "../../hooks/useAuth";
// Profile sidemenu content

// Drawer width for mobile ui
const drawerWidth = 240;

const SideDrawer = ({ darkMode, mobileOpen, handleDrawerToggle }) => {
  const profileSideMenu = [
    {
      id: 1,
      name: "SETTINGS_USER_PROFILE",
      icon: <IoPersonSharp />,
      path: "/profile/user-profile",
    },
    {
      id: 2,
      name: "SETTINGS_KYC",
      icon: <AiFillIdcard />,
      path: "/profile/kyc",
    },
    {
      id: 3,
      name: "SETTINGS_LANGUAGE",
      icon: <IoLanguage />,
      path: "/profile/language",
    },
    {
      id: 4,
      name: "SETTINGS_THEME",
      icon: <IoIosSwitch />,
      path: "/profile/theme",
    },
    {
      id: 5,
      name: "SETTINGS_CHANGE_PASSWORD",
      icon: "",
      iconMask: darkMode ? KeyIconDark : KeyIconLight,
      path: "/profile/change-password",
    },
    {
      id: 6,
      name: "SETTINGS_CHANGE_EMAIL",
      icon: "",
      iconMask: !darkMode ? DocumentEditIconLight : DocumentEditIcon,
      path: "/profile/change-email",
    },
    {
      id: 7,
      name: "FOOTER_LINK_FAQS",
      icon: <BsQuestionOctagonFill />,
      path: "/frequently-asked-questions",
    },
    {
      id: 8,
      name: "FOOTER_LINK_PRIVACY_POLICY",
      icon: <MdLock />,
      path: "/privacy-policy",
    },
    {
      id: 9,
      name: "FOOTER_LINK_TERMS_CONDITION",
      icon: <CgLoadbarDoc />,
      path: "/terms-and-condition",
    },
    {
      id: 10,
      name: "FOOTER_LINK_CONTACT_US",
      icon: <GiBugleCall />,
      lightIcon: <GiBugleCall />,
      path: "/contact-us",
    },
  ];
  const { user, handleLogOut } = useAuth();

  // Settings toggler
  const [settingsExpanded, setSettingsExpanded] = React.useState(false);
  const [walletAddress, setWalletAddress] = useState("");
  const [openModal, setOpenModal] = React.useState(false);

  const [avatarAnchorEl, setAvatarAnchorEl] = useState(null);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const handleConnectWallet = async () => {
    handleCloseModal();
    if (typeof window.ethereum !== "undefined") {
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      setWalletAddress(accounts[0]);
    }
  };
  const handleDisconnectWallet = () => {
    if (walletAddress) {
      window.location.reload();
    }
  };
  const openAvatarMenu = Boolean(avatarAnchorEl);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [walletExpanded, setWalletExpanded] = React.useState(false);
  const handleWalletExpand = () => {
    setWalletExpanded(!walletExpanded);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpenAvatarMenu = (event) => {
    setAvatarAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const onDisconnect = () => {
    handleDisconnectWallet();
    localStorage.setItem("isWalletConnected", false);
    localStorage.setItem("walletType", "");
    handleCloseMenu();
  };
  const handleClickTrigger = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Settings expand toggler
  const handleSettingsExpand = () => {
    setSettingsExpanded(!settingsExpanded);
  };

  // Click handler
  const handleReRouting = (path) => {
    navigate(path);
    handleDrawerToggle();
  };

  const drawer = (
    <Box
      bgcolor={darkMode ? "#0A0407" : "#fff2f8"}
      sx={{ overflowX: "hidden", height: "100vh" }}
    >
      {/* App Toolbar */}
      <Toolbar />
      <List
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {user?.email ? (
          <>
            <ListItem
              disablePadding
              sx={{
                display: "flex",
                position: "relative",
                mt: -3,
                mb: 2,
              }}
            >
              <Stack width="100%">
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Avatar
                    onClick={handleOpenAvatarMenu}
                    alt={user?.userName}
                    src={NavUserAvatar}
                    sx={{
                      height: 80,
                      width: 80,
                      mt: 0.7,
                      cursor: "pointer",
                      display: "block",
                    }}
                  />
                </Stack>
              </Stack>
            </ListItem>
            <ListItem
              disablePadding
              sx={{
                my: 1,
                display: "flex",
                position: "relative",
                ml: 3,
              }}
            >
              <IconButton
                sx={{ display: "flex", alignItems: "center", gap: 2, pl: 2 }}
                onClick={() => handleReRouting("/mybids")}
              >
                <Typography component="span" color="secondary">
                  <GavelIcon />
                </Typography>
                <Typography color="secondary" variant="body2" component="span">
                  {t("ALL_BIDS")}
                </Typography>
              </IconButton>
            </ListItem>
            <ListItem
              disablePadding
              sx={{
                my: 1,
                display: "flex",
                position: "relative",
                ml: 3,
              }}
            >
              <IconButton
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  pl: 2,
                }}
                onClick={handleWalletExpand}
              >
                <Typography color="secondary" component="span">
                  {walletAddress ? (
                    darkMode ? (
                      <img
                        onClick={handleClickTrigger}
                        style={{ width: "20px", height: "20px" }}
                        src={MetaMaskIcon}
                        alt="Meta Mask Icon"
                      />
                    ) : (
                      <img
                        onClick={handleClickTrigger}
                        style={{ width: "20px", height: "20px" }}
                        src={MetaMaskIconLight}
                        alt="Meta Mask Icon"
                      />
                    )
                  ) : (
                    <Typography
                      onClick={handleOpenModal}
                      color="secondary"
                      component="span"
                    >
                      <FaWallet />
                    </Typography>
                  )}
                </Typography>
                <Typography color="secondary" variant="body2" component="span">
                  {walletAddress ? (
                    <>
                      <Typography
                        color="secondary"
                        variant="body2"
                        component="span"
                        onClick={() => handleWalletExpand()}
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <span color="secondary">{"wallet Connected"}</span>

                        {walletExpanded ? (
                          <Typography
                            component="span"
                            color="secondary"
                            sx={{
                              mt: 1,
                            }}
                          >
                            <BsChevronUp />
                          </Typography>
                        ) : (
                          <Typography
                            component="span"
                            color="secondary"
                            sx={{
                              mt: 1,
                            }}
                          >
                            {" "}
                            <BsChevronDown />
                          </Typography>
                        )}
                      </Typography>
                    </>
                  ) : (
                    <Typography
                      color="secondary"
                      variant="body2"
                      component="span"
                      onClick={handleOpenModal}
                    >
                      {t("NAV_CONNECT_WALLET")}
                    </Typography>
                  )}
                </Typography>
              </IconButton>
            </ListItem>
            {walletExpanded && walletAddress && (
              <>
                {
                  <List>
                    <ListItem
                      disablePadding
                      sx={{
                        ml: 9,
                      }}
                    >
                      <IconButton
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 3,
                        }}
                      >
                        <Typography component="span" color="secondary">
                          <AiFillWallet />
                        </Typography>

                        <Typography
                          variant="body2"
                          color="secondary"
                          sx={{ fontSize: "11px" }}
                        >
                          {walletAddress.slice(0, 10)}
                        </Typography>
                      </IconButton>
                    </ListItem>
                    <ListItem
                      onClick={() => navigate("/user/dummy")}
                      disablePadding
                      sx={{
                        ml: 9,
                      }}
                    >
                      <IconButton
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 3,
                        }}
                      >
                        <Typography component="span" color="secondary">
                          <AiFillWallet />
                        </Typography>

                        <Typography
                          variant="body2"
                          color="secondary"
                          sx={{ fontSize: "11px" }}
                        >
                          {t("MY_PROFILE")}
                        </Typography>
                      </IconButton>
                    </ListItem>
                    <ListItem
                      disablePadding
                      sx={{
                        ml: 9,
                      }}
                    >
                      <IconButton
                        onClick={onDisconnect}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 3,
                        }}
                      >
                        <Typography component="span" color="secondary">
                          <TiCancel />
                        </Typography>

                        <Typography
                          variant="body2"
                          color="secondary"
                          sx={{ fontSize: "11px" }}
                        >
                          {t("DISCONNECT")}
                        </Typography>
                      </IconButton>
                    </ListItem>
                  </List>
                }
              </>
            )}
          </>
        ) : (
          <ListItem
            disablePadding
            sx={{
              my: 1,
              display: "flex",
              position: "relative",
              ml: 2,
            }}
          >
            <IconButton
              sx={{ display: "flex", alignItems: "center", gap: 2, pl: 2 }}
              onClick={() => handleReRouting("/authentication/sign-in")}
            >
              <Typography component="span" color="secondary">
                <LoginIcon />
              </Typography>
              <Typography color="secondary" variant="body2" component="span">
                {t("SIGNUP_LOGIN")}
              </Typography>
            </IconButton>
          </ListItem>
        )}

        <ConnectWalletPopUp
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          darkMode={darkMode}
          handleConnectWallet={handleConnectWallet}
          handleDisconnectWallet={handleDisconnectWallet}
          walletAddress={walletAddress}
        />
        <ListItem
          disablePadding
          sx={{
            my: 1,
            display: "flex",
            position: "relative",
            ml: 3,
          }}
        >
          {location.pathname ===
          `/trending-sellers${location.pathname.slice(17)}` ? (
            <div
              style={{
                background:
                  "linear-gradient(91.95deg, #2175D7 1.75%, #5ACDFE 98.13%)",
                borderRadius: "4px",
                width: "100%",
                height: "50px",
                position: "absolute",
              }}
            ></div>
          ) : null}
          <IconButton
            sx={{ display: "flex", alignItems: "center", gap: 2, pl: 2 }}
            onClick={() => handleReRouting("/trending-sellers")}
          >
            {location.pathname === "/trending-sellers" ? (
              <Typography component="span" color="#ffffff">
                <BsFillStarFill />
              </Typography>
            ) : (
              <Typography component="span" color="secondary">
                <BsFillStarFill />
              </Typography>
            )}

            <Typography color="secondary" variant="body2" component="span">
              {t("TRENDING_SELLERS")}
            </Typography>
          </IconButton>
        </ListItem>
        <ListItem
          disablePadding
          sx={{
            my: 1,
            display: "flex",
            position: "relative",
            ml: 3,
          }}
        >
          {location.pathname === "/trending-creators" ? (
            <div
              style={{
                background:
                  "linear-gradient(91.95deg, #2175D7 1.75%, #5ACDFE 98.13%)",
                borderRadius: "4px",
                width: "100%",
                height: "50px",
                position: "absolute",
              }}
            ></div>
          ) : null}
          <IconButton
            sx={{ display: "flex", alignItems: "center", gap: 2, pl: 2 }}
            onClick={() => handleReRouting("/trending-creators")}
          >
            {location.pathname === "/trending-creators" ? (
              <Typography component="span" color="#ffffff">
                <BsLightbulbFill />
              </Typography>
            ) : (
              <Typography component="span" color="secondary">
                <BsLightbulbFill />
              </Typography>
            )}
            <Typography color="secondary" variant="body2" component="span">
              {t("TRENDING_CREATORS")}
            </Typography>
          </IconButton>
        </ListItem>
        <ListItem
          disablePadding
          sx={{
            my: 1,
            display: "flex",
            position: "relative",
            ml: 3,
          }}
        >
          {location.pathname === "/favourites" ? (
            <div
              style={{
                background:
                  "linear-gradient(91.95deg, #2175D7 1.75%, #5ACDFE 98.13%)",
                borderRadius: "4px",
                width: "100%",
                height: "50px",
                position: "absolute",
              }}
            ></div>
          ) : null}
          <IconButton
            sx={{ display: "flex", alignItems: "center", gap: 2, pl: 2 }}
            onClick={() => handleReRouting("/favourites?type=nft-bookmark")}
          >
            {location.pathname === "/favourites" ? (
              <Typography component="span" color="#ffffff">
                <BsFillBookmarkFill />
              </Typography>
            ) : (
              <Typography component="span" color="secondary">
                <BsFillBookmarkFill />
              </Typography>
            )}
            <Typography color="secondary" variant="body2" component="span">
              {t("FAVOURITES")}
            </Typography>
          </IconButton>
        </ListItem>
        <ListItem
          disablePadding
          sx={{
            my: 1,
            display: "flex",
            position: "relative",
            ml: 3,
          }}
        >
          {location.pathname === "/user/dummy" ? (
            <div
              style={{
                background:
                  "linear-gradient(91.95deg, #2175D7 1.75%, #5ACDFE 98.13%)",
                borderRadius: "4px",
                width: "100%",
                height: "50px",
                position: "absolute",
              }}
            ></div>
          ) : null}
          <IconButton
            sx={{ display: "flex", alignItems: "center", gap: 2, pl: 2 }}
            onClick={() => handleReRouting("/user/dummy")}
          >
            {location.pathname === "/user/dummy" ? (
              <Typography component="span" color="#ffffff">
                <IoPersonSharp />
              </Typography>
            ) : (
              <Typography component="span" color="secondary">
                <IoPersonSharp />
              </Typography>
            )}
            <Typography color="secondary" variant="body2" component="span">
              {t("MY_PROFILE")}
            </Typography>
          </IconButton>
        </ListItem>
        <ListItem
          disablePadding
          sx={{
            my: 1,
            display: "flex",
            position: "relative",
            ml: 3,
          }}
        >
          {location.pathname === "/user/dummy" ? (
            <div
              style={{
                background:
                  "linear-gradient(91.95deg, #2175D7 1.75%, #5ACDFE 98.13%)",
                borderRadius: "4px",
                width: "100%",
                height: "50px",
                position: "absolute",
              }}
            ></div>
          ) : null}
          <IconButton
            sx={{ display: "flex", alignItems: "center", gap: 2, pl: 2 }}
            onClick={() => handleReRouting("/user/dummy")}
          >
            {location.pathname === "/user/dummy" ? (
              <Typography component="span" color="#ffffff">
                <IoPersonSharp />
              </Typography>
            ) : (
              <Typography component="span" color="secondary">
                <IoPersonSharp />
              </Typography>
            )}
            <Typography color="secondary" variant="body2" component="span">
              {t("MY_PROFILE")}
            </Typography>
          </IconButton>
        </ListItem>
        <ListItem
          disablePadding
          sx={{
            my: 1,
            display: "flex",
            position: "relative",
            ml: 3,
          }}
        >
          {location.pathname === `/profile${location.pathname?.slice(8)}` ? (
            <div
              style={{
                background:
                  "linear-gradient(91.95deg, #2175D7 1.75%, #5ACDFE 98.13%)",
                borderRadius: "4px",
                width: "100%",
                height: "50px",
                position: "absolute",
              }}
            ></div>
          ) : null}
          <IconButton
            sx={{ display: "flex", alignItems: "center", gap: 2, pl: 2 }}
            onClick={handleSettingsExpand}
          >
            {location.pathname === `/profile${location.pathname?.slice(8)}` ? (
              <Typography component="span" color="#ffffff">
                <BsGearFill />
              </Typography>
            ) : (
              <Typography component="span" color="secondary">
                <BsGearFill />
              </Typography>
            )}
            <Typography
              color="secondary"
              variant="body2"
              component="span"
              sx={{ display: "flex", alignItems: "center", gap: 2 }}
            >
              {t("SETTINGS")}
              {settingsExpanded ? (
                <Typography component="span" color="secondary">
                  <BsChevronDown />
                </Typography>
              ) : (
                <Typography component="span" color="secondary">
                  <BsChevronUp />
                </Typography>
              )}
            </Typography>
          </IconButton>
        </ListItem>
        {settingsExpanded && (
          <>
            {profileSideMenu.map((pfs) => (
              <ListItem
                disablePadding
                sx={{
                  ml: 9,
                  mt: 2,
                }}
                key={pfs.id}
              >
                {location.pathname === pfs.path ? (
                  <div
                    style={{
                      background:
                        "linear-gradient(91.95deg, #2175D7 1.75%, #5ACDFE 98.13%)",
                      borderRadius: "4px",
                      width: "100%",
                      height: "50px",
                      position: "absolute",
                    }}
                  ></div>
                ) : null}
                {pfs.icon ? (
                  <IconButton
                    onClick={() => handleReRouting(`${pfs.path}`)}
                    sx={{ display: "flex", alignItems: "center", gap: 3 }}
                  >
                    {location.pathname === pfs.path ? (
                      <Typography component="span" color="#ffffff">
                        {pfs.icon}
                      </Typography>
                    ) : (
                      <Typography component="span" color="secondary">
                        {pfs.icon}
                      </Typography>
                    )}
                    <Typography
                      variant="body2"
                      color="secondary"
                      sx={{ fontSize: "11px" }}
                    >
                      {t(`${pfs.name}`)}
                    </Typography>
                  </IconButton>
                ) : (
                  <IconButton
                    onClick={() => handleReRouting(`${pfs.path}`)}
                    sx={{ display: "flex", alignItems: "center", gap: 3 }}
                  >
                    <img src={pfs.iconMask} alt={pfs.name} />
                    <Typography
                      variant="body2"
                      color="secondary"
                      sx={{ fontSize: "11px" }}
                    >
                      {t(`${pfs.name}`)}
                    </Typography>
                  </IconButton>
                )}
              </ListItem>
            ))}
          </>
        )}
        {user?.email && (
          <ListItem
            disablePadding
            sx={{
              my: 1,
              display: "flex",
              position: "relative",
              ml: 3,
            }}
          >
            <IconButton
              sx={{ display: "flex", alignItems: "center", gap: 2, pl: 2 }}
              onClick={() => {
                handleLogOut(navigate);
              }}
            >
              <Typography component="span" color="secondary">
                <LogoutIcon />
              </Typography>
              <Typography color="secondary" variant="body2" component="span">
                {t("LOGOUT")}
              </Typography>
            </IconButton>
          </ListItem>
        )}
      </List>
      <Box sx={{ px: 2, mt: 17 }}>
        <>
          {darkMode ? (
            <img src={SideFooterLogoDark} alt="Side Footer Main Minto Logo" />
          ) : (
            <img src={SideFooterLogoLight} alt="Side Footer Main Minto Logo" />
          )}

          <Typography
            sx={{ color: "#D71869", my: 1 }}
            variant="subtitle2"
            component="h6"
          >
            {t("FOOTER_TITLE_MAIN")}
          </Typography>
          <Typography sx={{ color: "gray" }} variant="caption" component="p">
            {t("FOOTER_DETAILS")}
          </Typography>
        </>
        <IconButton sx={{ ml: -0.8, mt: 2 }}>
          <Typography component="span" color="secondary">
            <RiTwitterFill />
          </Typography>
        </IconButton>
        <IconButton sx={{ mt: 2 }}>
          <Typography component="span" color="secondary">
            <RiInstagramLine />
          </Typography>
        </IconButton>
        <Typography
          variant="caption"
          component="div"
          sx={{ color: "gray", textAlign: "left", fontSize: "7px", mt: 1 }}
        >
          &copy; 2023 {t("FOOTER_COPYRIGHT")}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <>
      {/* The Drawer Component */}
      <Drawer
        anchor="right"
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          zIndex: 200000,
          display: { xs: "block", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default SideDrawer;
